var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCautionSvgrepoCom2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "caution-svgrepo-com 2",
    clipPath: "url(#clip0_1465_2850)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0041 15.8965C9.25655 15.8965 8.64844 16.5057 8.64844 17.2549C8.64844 18.0041 9.25655 18.6138 10.0041 18.6138C10.7517 18.6138 11.3598 18.0046 11.3598 17.2549C11.3598 16.5062 10.7517 15.8965 10.0041 15.8965ZM10.0041 18.0732C9.55438 18.0732 9.18898 17.7062 9.18898 17.2549C9.18898 16.8035 9.55438 16.437 10.0041 16.437C10.4538 16.437 10.8192 16.8041 10.8192 17.2549C10.8192 17.7057 10.4538 18.0732 10.0041 18.0732Z",
    fill: "#E6A813",
    stroke: "#E6A813",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0039 6.05469C9.10984 6.05469 8.38227 6.73847 8.38281 7.59523L8.73687 13.5606C8.73687 14.1909 9.28011 14.7039 9.94768 14.7039C10.6152 14.7039 11.1585 14.1909 11.1574 13.5817L11.6255 7.57901C11.6255 6.73847 10.8979 6.05469 10.0039 6.05469ZM10.6179 13.5601C10.6179 13.8925 10.3174 14.1628 9.94768 14.1628C9.57795 14.1628 9.27741 13.8925 9.27687 13.5439L8.92281 7.57901C8.92281 7.03685 9.40768 6.59523 10.0039 6.59523C10.6001 6.59523 11.085 7.03631 11.0855 7.55793L10.6179 13.5601Z",
    fill: "#E6A813",
    stroke: "#E6A813",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.94231 17.5678H6.72231C6.8715 17.5678 6.99258 17.4467 6.99258 17.2975C6.99258 17.1483 6.8715 17.0272 6.72231 17.0272H1.94231C1.41853 17.0272 0.95799 16.7548 0.710422 16.298C0.467179 15.8494 0.48826 15.3256 0.767179 14.8975L8.8261 2.52562C9.08448 2.12886 9.52394 1.8921 10.0012 1.8921C10.4785 1.8921 10.918 2.12886 11.1764 2.52562L19.2353 14.8975C19.5142 15.3256 19.5353 15.8494 19.292 16.298C19.0445 16.7548 18.5839 17.0272 18.0602 17.0272H13.2802C13.131 17.0272 13.0099 17.1483 13.0099 17.2975C13.0099 17.4467 13.131 17.5678 13.2802 17.5678H18.0602C18.7856 17.5678 19.4234 17.1894 19.7672 16.5553C20.1066 15.9294 20.0769 15.1991 19.6883 14.6018L11.6293 2.23048C11.271 1.67967 10.6623 1.35156 10.0012 1.35156C9.34015 1.35156 8.7315 1.68021 8.37313 2.23048L0.314206 14.6024C-0.0749832 15.1997 -0.104172 15.9299 0.235287 16.5559C0.57853 17.1894 1.21691 17.5678 1.94231 17.5678Z",
    fill: "#E6A813",
    stroke: "#E6A813",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1465_2850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionSvgrepoCom2);
export default __webpack_public_path__ + "static/media/caution-svgrepo-com 2.9bb1c3fafdc575749a396f6f2376463b.svg";
export { ForwardRef as ReactComponent };